module.exports = __webpack_public_path__ + "static/media/icon_exclamation-octagon.a4f1bcbd.svg";